import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3v8h5L7 7l4 1V3H3zm5 10H3v8h8v-5l-4 1 1-4zm9 4l-4-1v5h8v-8h-5l1 4zm4-14h-8v5l4-1-1 4h5V3z"
}), 'PagesSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PagesSharp.js
// module id = 5169
// module chunks = 2